import { takeLatest, put, call } from "redux-saga/effects";
import { handleApiError } from "@utils/errorHandler";

import { loadAllContact, loadSingleContact } from "./ContactList.slice";

import { loadAllContactAPI, loadSingleContactAPI } from "./ContactList.api";

export const LOAD_ALL_CONTACT = {
  LOADING: "Load all contact loading",
  SUCCESS: "Load all contact success",
  ERROR: "Load all contact error",
};

export const LOAD_SINGLE_CONTACT = {
  LOADING: "Load single contact loading",
  SUCCESS: "Load single contact success",
  ERROR: "Load single contact error",
};

function* loadAllContactWorker(action) {
  const { payload } = action;

  try {
    const data = yield call(loadAllContactAPI, payload);
    yield put(loadAllContact(data));
  } catch (error) {
    handleApiError(error);
    yield put({ type: LOAD_ALL_CONTACT.ERROR, error });
  }
}

function* loadSingleContactSagaWorker(action) {
  const { payload } = action;

  try {
    const data = yield call(loadSingleContactAPI, payload);
    yield put(loadSingleContact(data));
  } catch (error) {
    handleApiError(error);
    yield put({ type: LOAD_SINGLE_CONTACT.ERROR, error });
  }
}

export function* loadAllContactSaga() {
  yield takeLatest(LOAD_ALL_CONTACT.LOADING, loadAllContactWorker);
}

export function* loadSingleContactSaga() {
  yield takeLatest(LOAD_SINGLE_CONTACT.LOADING, loadSingleContactSagaWorker);
}
